
export default {
    methods: {
        setStep (step) {
            this.$emit('setStep', step)
        },
    },
}
